import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

// Utility function to convert milliseconds to seconds
function msToSeconds(...values) {
    return values.map(value => value * 0.001);
}

const defaultConfig = {
    duration: 300,
    delay: 300,
    start: 'top 90%',
    end: 'bottom top'
};

const animationLibrary = {
    fadeIn: {
        from: { opacity: 0 },
        to: { opacity: 1 }
    },
    fadeOut: {
        from: { opacity: 1 },
        to: { opacity: 0 }
    },
    zoomIn: {
        from: { scale: 0.75, opacity: 0 },
        to: { scale: 1, opacity: 1 }
    },
    zoomOut: {
        from: { scale: 1, opacity: 1 },
        to: { scale: 0.5, opacity: 0 }
    },
    slideIn: {
        from: { x: '100%', opacity: 0 },
        to: { x: '0%', opacity: 1 }
    },
    slideOut: {
        from: { x: '0%', opacity: 1 },
        to: { x: '-100%', opacity: 0 }
    }
};

// Include GSAP and ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

// Function to apply animations based on data attributes
function applyAnimations() {
    document.querySelectorAll('[data-scroll-animation]').forEach(el => {

        const animationType = el.getAttribute('data-scroll-animation');
        const start = el.getAttribute('data-scroll-start') || defaultConfig.start;
        const durationMs = parseInt(el.getAttribute('data-scroll-duration')) || defaultConfig.duration; // ms
        const delayMs = parseInt(el.getAttribute('data-scroll-delay')) || defaultConfig.delay; // ms

        // Convert both duration and delay to seconds
        const [duration, delay] = msToSeconds(durationMs, delayMs);

        const animationConfig = animationLibrary[animationType];

        if (animationConfig) {
            gsap.from(el, {
                ...animationConfig.from,
                duration: duration, // GSAP expects seconds
                delay: delay,       // GSAP expects seconds
                ease: "power2.out",
                scrollTrigger: {
                    trigger: el,
                    start: start,
                    end: defaultConfig.end,
                    onEnter: () => {
                        gsap.to(el, {
                            ...animationConfig.to,
                            duration: duration, // Apply duration in seconds
                            delay: delay        // Ensure delay is applied in seconds
                        });
                    }
                }
            });
        }
    });
}

// Initialize animations
applyAnimations();
